import * as z from "zod";
import { ProductNameFilterQuery } from "../../product-name-filter";
import { makeReportFilterSchema } from "./base-report-filter";
import { ReportFilterType } from "./report-filter-type";

const ProductNameFilterSchema_ = makeReportFilterSchema(
  ReportFilterType.PRODUCT_NAME,
  ProductNameFilterQuery,
  z.array(z.string()),
);
export const ProductNameFilterSchema: z.ZodType<ProductNameFilter> =
  ProductNameFilterSchema_;
export interface ProductNameFilter
  extends z.infer<typeof ProductNameFilterSchema_> {}
